// check for hero elements with hero--with-pin-and-dot class and add the pin/connector line html
const heroElement = document.querySelector('.hero--with-pin-and-dot');
if (heroElement) {
  const pinHTML = `
    <div class="hero-pin-container">
        <div class="pin-and-connector-line location-connector">
            <i id="location-icon" class="fa-solid fa-location-dot"></i>
            <div id="location-connector-line" class="location-connector-line"></div>
        </div>
    </div>
  `;
  heroElement.insertAdjacentHTML('afterend', pinHTML);
}

// determine height the connector line should be and update as needed
function updateConnectorLine() {
    const icon = document.getElementById('location-icon');
    const dot = document.getElementById('location-dot');
    const line = document.getElementById('location-connector-line');

    if (!icon || !dot || !line) return;

    const iconRect = icon.getBoundingClientRect();
    const dotRect = dot.getBoundingClientRect();

    const scrollY = window.scrollY;
    const scrollX = window.scrollX;

    const startX = iconRect.left + iconRect.width / 2 + scrollX - 2;
    const startY = iconRect.bottom + scrollY;
    let endY = dotRect.top + scrollY;

    if (window.innerWidth < 1460) {
        endY -= 38; 
    } else {
        endY -= 48; 
    }

    line.style.left = `${startX}px`;
    line.style.height = `${endY - startY}px`;
}

window.addEventListener('DOMContentLoaded', updateConnectorLine);
window.addEventListener('resize', updateConnectorLine);
window.addEventListener('scroll', updateConnectorLine);